import React from "react";
import "../Css/footer.css"

const Footer = () => {
  /* function toTop() {
    window.scrollTo(0, 0)
  } */
  return (
    <div className="footer-container">
      < footer className="footer" >
        {/*  <button onClick={toTop} className="col-span-2 flex items-center space-x-2 w-fit group 2xl:text-body-1"><span className="font-extrabold uppercase hover:font-black duration-200">BACK TO TOP</span></button> */}
        <div className="footer-column">
          <div className="footer-column-inner">
            <p>
              <br />
              <br />
              <span className="frase-footer">
                ¿Qué temes perder, <br /> si nada en este mundo nos pertenece?
              </span>
              <br />
              <br />
              <b>Bhagwat Gita</b>
            </p>
          </div>
        </div>
        <div className="footer-column">
          <div className="footer-column-inner">
            <h4>Links</h4>
            <ul>
              <li><a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/clusttec">LinkedIn <img loading="lazy" src="/Logos/redir-icon.png" alt="Open in new window" className="redir-icon" /></a></li>
              <li><a target="_blank" rel="noopener noreferrer" href="/">Instagram <img loading="lazy" src="/Logos/redir-icon.png" alt="Open in new window" className="redir-icon" /></a></li>
              <li><a target="_blank" rel="noopener noreferrer" href="/">Youtube <img loading="lazy" src="/Logos/redir-icon.png" alt="Open in new window" className="redir-icon" /></a></li>
              <li><a target="_blank" rel="noopener noreferrer" href="/">Tick Tock <img loading="lazy" src="/Logos/redir-icon.png" alt="Open in new window" className="redir-icon" /></a></li>
            </ul>
          </div>
        </div>
        <div className="footer-column">
          <div className="footer-column-inner">
            <h4>Contacto</h4>
            <p>Tel: +54 911 2485 6291</p>
            <p>Dir: San Martin 3400, Vicente López</p>
            <p>Horarios: Lu a Vie de 8 a 17hs</p>
          </div>
        </div>
      </footer >
      <h3 className="Privacy">© 2025 ClustTec. All rights reserved. <a href="/PyP.pdf" className="footerPP">Política de Privacidad</a></h3>
    </div>
  );
};

export default Footer;



